"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lang_1 = require("../../lang");
var define_context_1 = require("../function/define-context");
var generate_context_name_1 = require("../function/generate-context-name");
exports.context = function (contextNameOrPrototype, propName) {
    if (typeof contextNameOrPrototype !== lang_1.TYPE_OBJECT) {
        // @context('some-unique-name') case
        return function (prototype, propName) {
            //console.log('!!!', prototype, propName!, contextNameOrPrototype)
            // in case contextName is not set, generate a pseudo-unique name
            define_context_1.defineContext(prototype, propName, contextNameOrPrototype);
        };
    }
    else {
        //console.log('???', contextNameOrPrototype, propName!, generateContextName(contextNameOrPrototype.constructor.name, propName!))
        // @context case
        define_context_1.defineContext(contextNameOrPrototype, propName, generate_context_name_1.generateContextName(contextNameOrPrototype.constructor.name, propName));
    }
};
//# sourceMappingURL=context.js.map